import HttpService, { HttpMethods } from '@lwt-common/http-service/HttpService';
import { getToken } from '../functions/AuthenticationFunctions';

export const useHttpService = (abortController) => {
    const sendRequest = async (
        url,
        body,
        {
            useToken = true,
            skipCache = true,
            ...options
        } = {}
    ) => {

        const onFailure = error => {
            if (options.onFailure) {
                options.onFailure(error);
            } else {
                //perform some default behaviour with api errors
            }
        };

        const headers = new Headers();

        headers.append('Content-Type', options.contentType || 'application/json');
        headers.append('Cache-Control', 'no-cache');

        if (useToken) {
            headers.append('Authorization', `Bearer ${getToken()}`);
        }

        if (options.additionalHeaders) {
            for (const [key, value] of Object.entries(options.additionalHeaders)) {
                headers.append(key, value);
            }
        }

        const init = {
            method: options.method || HttpMethods.GET,
            headers: headers
        };

        const request = new Request(encodeURI(url), init);

        const requestData = body
            ? {
                body: options.contentType === 'application/x-www-form-urlencoded'
                    ? body
                    : JSON.stringify(body)
            }
            : {};

        const { error, response } = await forPromise(HttpService.request(
            request,
                {
                    signal: abortController.signal,
                    ...requestData,
                },
                skipCache
        ));

        // Only run the callBack if the error didn't result from the request being aborted
        if (error && error.code !== 20) {
            onFailure(error);
        }

        if (options.requestOrder !== undefined) {
            return {
                order: options.requestOrder,
                body: response
            }
        } else {
            return response;
        }
    };
    return { sendRequest };
};

export const forPromise = promise => promise
        .then(response => {
            return { error: null, response };
        })
        .catch(error => {
            return { error, response: null };
        });


export default useHttpService;